// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => Vendor.loadInternal(), entryList => {
        Vendor.θentryList.set(entryList)
        Vendor.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class Vendor {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["name", "street", "city", "country", "email", "language", "turningOnLathe", "flatMachining", "bending"] as const,
        allPropertyNames: ["id", "name", "street", "city", "country", "email", "language", "turningOnLathe", "flatMachining", "bending"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<Vendor.Id | null>;
    static readonly Id = Number;
    static ids: Vendor.Id[] = [] as any;
    static idsAndDisplayValues: Record<Vendor.Id, string> = {} as any;
    static θentryList = signal<Vendor.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<Vendor.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'id';
    [immerable] = true;
    readonly θname = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.name : undefined
    });
    readonly θstreet = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.street : undefined
    });
    readonly θcity = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.city : undefined
    });
    readonly θcountry = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.country : undefined
    });
    readonly θemail = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.email : undefined
    });
    readonly θlanguage = computed(() => {
        const id = this.θid()
        return id !== null ? new Orders.VendorLanguage(Vendor.getEntryMap()[id]?.language) : undefined
    });
    readonly θturningOnLathe = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.turningOnLathe : undefined
    });
    readonly θflatMachining = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.flatMachining : undefined
    });
    readonly θbending = computed(() => {
        const id = this.θid()
        return id !== null ? Vendor.getEntryMap()[id]?.bending : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return Vendor[BoInfoSymbol]
    }

    get __type(): 'Orders.Vendor' {
        return 'Orders.Vendor'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.Vendor' {
        return 'Orders.Vendor'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): Vendor.Id | null {
        return this.θid()
    }

    set id(id: Vendor.Id | Vendor | null) {
        if (id !== null && typeof id == 'object') { id = id.id }



        this.θid.set(id as Vendor.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): Vendor.Id[] {
        return Vendor.ids
    }

    get idsAndDisplayValues(): Record<Vendor.Id, string> {
        return Vendor.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[Vendor.$displayProperty])
    }

    get name() {
        return this.θname()
    }

    get street() {
        return this.θstreet()
    }

    get city() {
        return this.θcity()
    }

    get country() {
        return this.θcountry()
    }

    get email() {
        return this.θemail()
    }

    get language() {
        return this.θlanguage()
    }

    get turningOnLathe() {
        return this.θturningOnLathe()
    }

    get flatMachining() {
        return this.θflatMachining()
    }

    get bending() {
        return this.θbending()
    }

    constructor(idOrObject: Vendor.Id | Vendor | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): Vendor.Entry[] {
        return This.Vendor.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): Vendor.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: Vendor.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof Vendor.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = Vendor.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<Vendor.Entry[]> {
        async function getDynamicEntries() {
            try {
                return ExecutionService.executeMethodAndReturnData<any[]>('StaticEntity', 'Orders', 'Vendor', undefined, 'getEntryList', [])
            } catch (err: any) {
                console.error('Error loading dynamic entries for Orders.Vendor:', err)
                return []
            }

        }

        const dynamicEntryList = await getDynamicEntries()
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new Vendor(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: Vendor.Id | Vendor | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as Vendor.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: Vendor.Id | Vendor) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<Vendor.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.Vendor yet:', err.message)
            //throw err
        })
    }

    static θgetStaticEntryList() {
        return Object.freeze([

        ] as Vendor.Entry[]) as Vendor.Entry[]
    }
}
jsonClass('Orders.Vendor')(Vendor)

export const VendorθId = Number;

export type VendorθId = number;

export namespace Vendor {
    export type Id = number

    export interface Entry {
        id: Vendor.Id;
        name: string;
        street: string;
        city: string;
        country: string;
        email: string;
        language: Orders.VendorLanguage.Id;
        turningOnLathe: boolean;
        flatMachining: boolean;
        bending: boolean;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => Vendor.load(true))
